import React, { useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import ArrowDropDownSharpIcon from '@mui/icons-material/ArrowDropDownSharp';
import ArrowDropUpSharpIcon from '@mui/icons-material/ArrowDropUpSharp';
import google from '../Assets/Dashboard/stock-google.png'
import apple from '../Assets/Dashboard/stock-apple.png'
import netflix from '../Assets/Dashboard/stock-netflix.png'
import { CommonResponseModel, CommonResponseSecondaryModel, MarketingPortfolioResponseModel, MarketingViewDetailResponseModel, Plan401kDetailsModel, } from "../models/axiosModels";
import { DashboardResponseModel, getRevenuePayloadData, MarketAndSalesResourcePayloadDataModel, MarketAndSalesResourcesResponseModel, RevenueDataResponseDataModel, ResourceFileData, UserProfileDetailsResponseDataModel } from "../models/dashboardAxiosModels";
import agent from "../Services/api";
import dayjs from "dayjs";
import { plan401kDetailsInitialize } from "../Utils/Constant/DashboardConstant";
import { UserAppsResponse } from "../models/userDetailsModel";

const DashboardContext = React.createContext<DashboardDetailPayload | undefined>(
    undefined
);

export interface DashboardDetailPayload {

    stockMarqueDetails: any;
    setStockMarqueDetails: React.Dispatch<React.SetStateAction<any>>


    dashboardDetails: UserAppsResponse | null;
    setDashboardDetails: React.Dispatch<React.SetStateAction<UserAppsResponse | null>>
    getRevenueData: (payload: getRevenuePayloadData) => Promise<CommonResponseSecondaryModel<RevenueDataResponseDataModel>>;
    revenueGeneratePdf: (payload: getRevenuePayloadData) => Promise<CommonResponseSecondaryModel<Blob>>;

    dashboardRevenueDetails: RevenueDataResponseDataModel | null;
    setDashboardRevenueDetails: React.Dispatch<React.SetStateAction<RevenueDataResponseDataModel | null>>

    dashboardRevenuePayload: getRevenuePayloadData | null;
    setDashboardRevenuePayload: React.Dispatch<React.SetStateAction<getRevenuePayloadData | null>>

    marketingViewDetails: MarketingViewDetailResponseModel | null;
    setMarketingViewDetails: React.Dispatch<React.SetStateAction<MarketingViewDetailResponseModel | null>>

    marketingPortfolioDetails: MarketingPortfolioResponseModel | null;
    setMarketingPortfolioDetails: React.Dispatch<React.SetStateAction<MarketingPortfolioResponseModel | null>>

    marketAndSalesResourceDetails: MarketAndSalesResourcesResponseModel[];
    setMarketAndSalesResourceDetails: React.Dispatch<React.SetStateAction<MarketAndSalesResourcesResponseModel[]>>
    getMarketAndSalesDetails: () => Promise<CommonResponseSecondaryModel<MarketAndSalesResourcesResponseModel[]>>;

    marketingAndSalesResorcePayloadDetails: MarketAndSalesResourcePayloadDataModel | null;
    setMarketingAndSalesResorcePayloadDetails: React.Dispatch<React.SetStateAction<MarketAndSalesResourcePayloadDataModel | null>>;
    marketAndSalesResource: (payload: MarketAndSalesResourcePayloadDataModel) => Promise<CommonResponseSecondaryModel<MarketAndSalesResourcePayloadDataModel | null>>;

    uploadResourceFormData: any;
    setUploadResourceFormData: React.Dispatch<React.SetStateAction<any>>;
    // uploadResourceFile: (payload: any) => Promise<CommonResponseSecondaryModel<any>>;

    userDetails: UserProfileDetailsResponseDataModel;
    setUserDetails: React.Dispatch<React.SetStateAction<UserProfileDetailsResponseDataModel>>;

    plan401kDetails: Plan401kDetailsModel;
    setPlan401kDetails: React.Dispatch<React.SetStateAction<Plan401kDetailsModel>>;

    // TICKER
    tickerOptions: any | null;
    setTickerOptions: React.Dispatch<React.SetStateAction<any | null>>

    tickerCustomizeDialog: any | null;
    setTickerCustomizeDialog: React.Dispatch<React.SetStateAction<any | null>>

    tickerSaveDetails: any;
    setTickerSaveDetails: React.Dispatch<React.SetStateAction<any | null>>

    storedColorthemeOptions: any;
    setStoredColorthemeOptions: React.Dispatch<React.SetStateAction<any | null>>

    storedDisplayMode: any;
    setStoredDisplayMode: React.Dispatch<React.SetStateAction<any | null>>

    selectedStocks: any;
    setSelectedStocks: React.Dispatch<React.SetStateAction<any | null>>

    tickerSaveDetailsDsh: any;
    setTickerSaveDetailsDsh: React.Dispatch<React.SetStateAction<any | null>>
}

const DashboardProvider = ({ children }: ChildrenProps) => {


    const [stockMarqueDetails, setStockMarqueDetails] = useState<any>([
        {
            img: google,
            stockText: "Alphabet Inc.",
            stockArrow: <ArrowDropDownSharpIcon sx={{ color: "green", }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: apple,
            stockText: "Apple",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "red" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: netflix,
            stockText: "Netflix",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "green" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: google,
            stockText: "Alphabet Inc.",
            stockArrow: <ArrowDropDownSharpIcon sx={{ color: "green", }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: apple,
            stockText: "Apple",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "red" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: netflix,
            stockText: "Netflix",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "green" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: google,
            stockText: "Alphabet Inc.",
            stockArrow: <ArrowDropDownSharpIcon sx={{ color: "green", }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: apple,
            stockText: "Apple",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "red" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
        {
            img: netflix,
            stockText: "Netflix",
            stockArrow: <ArrowDropUpSharpIcon sx={{ color: "green" }} />,
            stockPrice: "$224.23 (-2.73/ -1.20%)"
        },
    ])

    const [dashboardDetails, setDashboardDetails] = useState<UserAppsResponse | null>(null)
    const [dashboardRevenueDetails, setDashboardRevenueDetails] = useState<RevenueDataResponseDataModel | null>(null)
    const [dashboardRevenuePayload, setDashboardRevenuePayload] = useState<any | null>(() => {
        const currentDate = dayjs();
        const lastMonth = currentDate.subtract(1, "month").format("MMMM-YYYY");
        return {
            months: [lastMonth, currentDate],
            flagShowAllAgentsData: false,
        };

    });

    const [marketingViewDetails, setMarketingViewDetails] = useState<MarketingViewDetailResponseModel | null>(null)
    const [marketingPortfolioDetails, setMarketingPortfolioDetails] = useState<MarketingPortfolioResponseModel | null>(null)

    // TICKER 
    const [tickerOptions, setTickerOptions] = useState<any>(null)
    const [tickerCustomizeDialog, setTickerCustomizeDialog] = useState(false)
    const [tickerSaveDetails, setTickerSaveDetails] = useState<any>({
        stockIds: [],
        stokesDetails: [],
        customizationOptions: {
            isLogoVisible: false,
            displayMode: "",
            colorTheme: "" // we'll update this
        }
    });
    const [tickerSaveDetailsDsh, setTickerSaveDetailsDsh] = useState<any>({
        stockIds: [],
        stokesDetails: [],
        customizationOptions: {
            isLogoVisible: false,
            displayMode: "",
            colorTheme: "" // we'll update this
        }
    });
    const [storedColorthemeOptions, setStoredColorthemeOptions] = useState<any>({
        "backgroundColors": [
            {
                "name": "Beige",
                "hex": "#f5f5dc",
                "theme": "Light",
                "description": "Neutral beige with timeless appeal and strong text contrast."
            },
            {
                "name": "Ash",
                "hex": "#f0f0f0",
                "theme": "Light",
                "description": "Soft grayish white for clean, minimal interfaces."
            },
            {
                "name": "Offwhite",
                "hex": "#fafafa",
                "theme": "Light",
                "description": "Very light gray with excellent readability for dark text."
            },
            {
                "name": "Sand",
                "hex": "#eae0c8",
                "theme": "Light",
                "description": "Earthy and elegant, complements red and green text naturally."
            },
            {
                "name": "Stone",
                "hex": "#d8d8d8",
                "theme": "Light",
                "description": "Balanced neutral gray, works well in modern UIs."
            },
            {
                "name": "Pearl",
                "hex": "#fdfdfd",
                "theme": "Light",
                "description": "Refined white tone with a soft touch, perfect for content-heavy areas."
            },
            {
                "name": "Taupe",
                "hex": "#e6ded1",
                "theme": "Light",
                "description": "Understated taupe that feels professional and grounded."
            },
            {
                "name": "Clay",
                "hex": "#dbd4cb",
                "theme": "Light",
                "description": "Subtle, neutral background ideal for structured data."
            },
            {
                "name": "Charcoal",
                "hex": "#232323",
                "theme": "Dark",
                "description": "Deep black-gray tone with excellent contrast for white and green text."
            },
            {
                "name": "Navy",
                "hex": "#0d1b2a",
                "theme": "Dark",
                "description": "Classic navy blue that feels serious and focused."
            },
            {
                "name": "Slate",
                "hex": "#2f3e46",
                "theme": "Dark",
                "description": "Dark slate green-blue; subtle and balanced."
            },
            {
                "name": "Onyx",
                "hex": "#1a1a1a",
                "theme": "Dark",
                "description": "Flat black with a smooth modern look."
            },
            {
                "name": "Graphite",
                "hex": "#3a3f44",
                "theme": "Dark",
                "description": "Slightly warm dark gray, ideal for readable content."
            },
            {
                "name": "Indigo",
                "hex": "#1e213a",
                "theme": "Dark",
                "description": "Dark indigo blue with great clarity for white text."
            },
            {
                "name": "Cocoa",
                "hex": "#2b1d1d",
                "theme": "Dark",
                "description": "Muted brown-black, warm and earthy."
            },
            {
                "name": "Olive",
                "hex": "#2c302e",
                "theme": "Dark",
                "description": "Dark olive-gray, a grounded alternative to charcoal."
            },
            {
                "name": "Ink",
                "hex": "#121417",
                "theme": "Dark",
                "description": "Ultra-dark blue-black, ideal for high-contrast designs."
            },
            {
                "name": "Steel",
                "hex": "#2a2d34",
                "theme": "Dark",
                "description": "Industrial dark gray with a modern aesthetic."
            },
            {
                "name": "Maroon",
                "hex": "#2e1a1a",
                "theme": "Dark",
                "description": "Dark reddish-brown with subtle color depth."
            },
            {
                "name": "Teal",
                "hex": "#1b2e2b",
                "theme": "Dark",
                "description": "Cool dark teal tone, distinctive yet comfortable."
            },
            {
                "name": "Shadow",
                "hex": "#1c1f24",
                "theme": "Dark",
                "description": "Deep shadow tone for focused, distraction-free UIs."
            },
            {
                "name": "Fog",
                "hex": "#3c3f41",
                "theme": "Dark",
                "description": "Soft dark gray with a hint of lightness for gentle contrast."
            }
        ]
    })
    const [storedDisplayMode, setStoredDisplayMode] = useState([
        {
            displayId: 1,
            displayName: "Adaptive"
        },
        {
            displayId: 2,
            displayName: "Regular"
        },
        {
            displayId: 3,
            displayName: "Compact"
        },
    ])
    const [selectedStocks, setSelectedStocks] = useState<any[]>([]);





    // MARKETING AND SALES RESOURCE 
    const [marketAndSalesResourceDetails, setMarketAndSalesResourceDetails] = useState<MarketAndSalesResourcesResponseModel[]>([])
    const [uploadResourceFormData, setUploadResourceFormData] = useState<any>(null)
    const [marketingAndSalesResorcePayloadDetails, setMarketingAndSalesResorcePayloadDetails] = useState<MarketAndSalesResourcePayloadDataModel | null>({
        categoryName: "",
        categoryID: null,
        description: "",
        hyperlink: null,
        hyperlink_name: null,
        google_storage_file_id: null,
        google_storage_thumbnail_id: null,
        file: null,
        thumbnail: null
    })

    const [userDetails, setUserDetails] = useState<UserProfileDetailsResponseDataModel>({
        email: "",
        isVerified: false,
        firstName: "",
        lastName: "",
        username: "",
        contact: "",
        profileImage: null,
        agencyName: "",
        addressLine1: "",
        addressLine2: "",
        zipcode: "",
        city: "",
        stateID: null,
        affiliated_BA: false,
        affiliated_Brooklight: false,
        admin: false,
        superadmin: false,
        createdAt: "",
        updatedAt: ""
    })
    const [plan401kDetails, setPlan401kDetails] = useState<Plan401kDetailsModel>(plan401kDetailsInitialize)


    const getRevenueData = async (payload: getRevenuePayloadData) => {
        const response = await agent.getRevenueDataAPI.post(payload);
        return response
    }

    const revenueGeneratePdf = async (payload: getRevenuePayloadData) => {
        const response = await agent.revenueGeneratePdfAPI.post(payload);
        return response
    }

    const getMarketAndSalesDetails = async () => {
        const response = await agent.getMarketAndSalesDetailsAPI.get();
        return response
    }

    const marketAndSalesResource = async (payload: MarketAndSalesResourcePayloadDataModel) => {
        const response = await agent.marketAndSalesResourceAPI.post(payload);
        return response;
    };

    // const uploadResourceFile = async (payload: any) => {
    //     const response = await agent.uploadResourceFileAPI.post(payload);
    //     return response;
    // };

    const payload = {
        stockMarqueDetails,
        setStockMarqueDetails,

        dashboardDetails,
        setDashboardDetails,

        dashboardRevenuePayload,
        setDashboardRevenuePayload,

        marketingViewDetails,
        setMarketingViewDetails,

        tickerOptions,
        setTickerOptions,

        marketingPortfolioDetails,
        setMarketingPortfolioDetails,
        getRevenueData,

        dashboardRevenueDetails,
        setDashboardRevenueDetails,

        revenueGeneratePdf,

        marketAndSalesResourceDetails,
        setMarketAndSalesResourceDetails,
        getMarketAndSalesDetails,


        marketingAndSalesResorcePayloadDetails,
        setMarketingAndSalesResorcePayloadDetails,
        marketAndSalesResource,

        uploadResourceFormData,
        setUploadResourceFormData,
        // uploadResourceFile,

        userDetails,
        setUserDetails,

        plan401kDetails,
        setPlan401kDetails,

        tickerCustomizeDialog,
        setTickerCustomizeDialog,

        tickerSaveDetails,
        setTickerSaveDetails,

        storedColorthemeOptions,
        setStoredColorthemeOptions,

        storedDisplayMode,
        setStoredDisplayMode,

        selectedStocks,
        setSelectedStocks,

        tickerSaveDetailsDsh,
        setTickerSaveDetailsDsh
    };

    return (
        <DashboardContext.Provider value={payload}>{children}</DashboardContext.Provider>
    );
};

export { DashboardContext, DashboardProvider };
